import { ExtraContentsScreen } from '@screens/ExtraContentsScreen'

/** Visão do produtor sobre o material complementar do curso. */
export default function AdminViewExtraContents() {
  return <ExtraContentsScreen />
}
